import { getTrades } from "./index"
import { chain, get, capitalize } from "lodash"
import { createSelector } from "reselect"
import { getViewType, getPortfolioName } from "modules/portfolio-root/selectors/portfolios"
import { getExcelValue } from "helpers/csv"

const TRADE_TYPES_ORDER = {
  buy: 1,
  sell: 2,
  short: 3,
  cover: 4,
}

const HEADERS = [
  "Trade Type",
  "Identifier",
  "MIC",
  "Bloomberg Ticker",
  "Country",
  "Asset Class",
  "Currency",
  "Industry",
  "Original Position Size",
  "Rebalanced Position Size",
  "Position $ Change",
  "Original Equity %",
  "Rebalanced Equity %",
  "Equity % Change",
]

const getDate = (state, props) => props.on
const getPortfolioGmv = state => get(state, "global.data.portfolioData.data.portfolio.dates.0.gmv")
const getPortfolioEquity = state => get(state, "global.data.portfolioData.data.portfolio.dates.0.equity")

const getWorkingEquity = createSelector(
  [getPortfolioEquity, getPortfolioGmv],
  (equity, gmv) => equity || gmv,
)

export const getFileName = createSelector(
  [getPortfolioName, getViewType, getDate],
  (portfolioName, viewType, date) => `${portfolioName} Optimizer Trades ${capitalize(viewType.substr(0, 3))} ${date}`,
)

export const getCsvRows = createSelector(
  [getTrades, getWorkingEquity],
  (trades, workingEquity) => [
    HEADERS,
    ...chain(trades)
      .sortBy([({ tradeType }) => TRADE_TYPES_ORDER[tradeType], "ticker"])
      .map(({
        tradeType,
        ticker,
        mic,
        bloombergTicker,
        country,
        currency,
        classification,
        originalPercentEquity,
        percentEquity,
        rebalancedPercentEquity,
      }) => ([
        tradeType,
        ticker,
        mic,
        bloombergTicker,
        country,
        "equity",
        currency,
        get(classification, "name"),
        getExcelValue(originalPercentEquity * workingEquity),
        getExcelValue(rebalancedPercentEquity * workingEquity),
        getExcelValue((rebalancedPercentEquity * workingEquity) - (originalPercentEquity * workingEquity)),
        getExcelValue(originalPercentEquity, { percent: true }),
        getExcelValue(rebalancedPercentEquity, { percent: true }),
        getExcelValue(percentEquity, { percent: true }),
      ]))
      .value(),
  ])
